import React from 'react';
import { Box, VStack } from '@chakra-ui/react';
import Wrapper from '@components/atoms/Wrapper';
import RichText from '@components/atoms/RichText';
import HeaderFont from '@components/atoms/HeaderFont';

const ContentBlockWithText = ({ data = null }) => {
  const { title, content } = data;
  return (
    <Wrapper narrow>
      <VStack
        pb={{ base: `14`, md: `16` }}
        textAlign={{ base: `left`, md: `center` }}>
        <Box
          as="h3"
          fontStyle="italic"
          color="purple.600"
          fontSize={{ base: `3xl`, md: `4xl` }}
          lineHeight={{ base: `2.494rem`, md: `2.7rem` }}>
          <HeaderFont>{title}</HeaderFont>
        </Box>
        {content && content.data.content.length > 0 && (
          <Box mb="3rem" fontSize={{ base: `sm`, md: `lg` }}>
            <RichText data={content.data.content} />
          </Box>
        )}
      </VStack>
    </Wrapper>
  );
};

export default ContentBlockWithText;
